import { twMerge } from "tailwind-merge";
import { TypeBase, type TypeBaseProps, type TypeVariant } from "@core/ui";

export type { TypeVariant };

export type Props = TypeBaseProps;

/**
 * Styled typography component wrapping TypeBase.
 * Provides consistent typography styles across the application.
 */
export const Type = ({
  variant = "h1",
  className = "",
  ...props
}: Props) => {
  const classes: Record<TypeVariant, string> = {
    h1: "[font-feature-settings:'ss10'] text-4xl tracking-[-1.76px] font-medium md:text-7xl print:text-3xl print:max-w-lg",
    h2: "[font-feature-settings:'ss10'] text-4xl tracking-[-1.12px] font-medium md:text-6xl print:text-xl print:max-w-lg",
    h3: "[font-feature-settings:'ss10'] text-xl tracking-[-0.72px] font-semibold md:text-4xl print:text-2xl print:max-w-lg",
    h4: "text-base tracking-[-0.4px] font-bold md:text-xl md:font-bold print:text-lg print:max-w-lg",
    h5: "text-sm font-bold md:text-sm print:text-sm print:max-w-lg",
    h6: "text-sm font-semibold md:text-sm print:text-sm print:max-w-lg",
    body1: "text-base font-normal max-w-3xl md:text-xl",
    body2: "text-base font-normal max-w-lg",
    caption: "text-sm font-normal md:text-sm max-w-2xl",
    small: "text-xs font-normal max-w-2xl",
    tiny: "text-xxs font-medium max-w-2xl",
  };

  return (
    <TypeBase
      variant={variant}
      className={twMerge(classes[variant], className)}
      {...props}
    />
  );
};

export default Type;

